import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetTitleListOfferProvidersQueryVariables = Types.Exact<{
	nodeId: Types.Scalars['ID']['input'];
	country: Types.Scalars['Country']['input'];
	first: Types.Scalars['Int']['input'];
	filter?: Types.InputMaybe<Types.TitleFilter>;
	offersFilter: Types.OfferFilter;
}>;

export type GetTitleListOfferProvidersQuery = {
	__typename?: 'Query';
	node?:
		| { __typename?: 'Article'; id: string }
		| { __typename?: 'Author'; id: string }
		| { __typename?: 'Bundle'; id: string }
		| { __typename?: 'Device'; id: string }
		| { __typename?: 'Episode'; id: string }
		| {
				__typename?: 'GenericTitleList';
				id: string;
				titles: {
					__typename?: 'GenericTitleListConnection';
					totalCount: number;
					edges?: Array<{
						__typename?: 'GenericTitleListEdge';
						nodeV2:
							| {
									__typename: 'Movie';
									id: string;
									flatrate: Array<{
										__typename?: 'Offer';
										id: string;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											clearName: string;
											shortName: string;
										};
									}>;
							  }
							| {
									__typename: 'Season';
									id: string;
									flatrate: Array<{
										__typename?: 'Offer';
										id: string;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											clearName: string;
											shortName: string;
										};
									}>;
							  }
							| {
									__typename: 'Show';
									id: string;
									flatrate: Array<{
										__typename?: 'Offer';
										id: string;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											clearName: string;
											shortName: string;
										};
									}>;
							  };
					}> | null;
				};
		  }
		| { __typename?: 'Genre'; id: string }
		| { __typename?: 'HomePage'; id: string }
		| { __typename?: 'Movie'; id: string }
		| { __typename?: 'MultiStepSportEvent'; id: string }
		| { __typename?: 'Offer'; id: string }
		| { __typename?: 'OfferHistory'; id: string }
		| { __typename?: 'Package'; id: string }
		| { __typename?: 'Page'; id: string }
		| { __typename?: 'Person'; id: string }
		| { __typename?: 'PressRelease'; id: string }
		| { __typename?: 'ProfileV2'; id: string }
		| { __typename?: 'Season'; id: string }
		| { __typename?: 'Show'; id: string }
		| { __typename?: 'SingleStepSportEvent'; id: string }
		| { __typename?: 'SportCompetitionV2'; id: string }
		| { __typename?: 'SportCompetitorV2'; id: string }
		| { __typename?: 'SportMatch'; id: string }
		| { __typename?: 'Url'; id: string }
		| { __typename?: 'UserProviderSubscription'; id: string }
		| null;
};

export type TitleListOfferProviderFragment = {
	__typename?: 'GenericTitleListEdge';
	nodeV2:
		| {
				__typename: 'Movie';
				id: string;
				flatrate: Array<{
					__typename?: 'Offer';
					id: string;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
					};
				}>;
		  }
		| {
				__typename: 'Season';
				id: string;
				flatrate: Array<{
					__typename?: 'Offer';
					id: string;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
					};
				}>;
		  }
		| {
				__typename: 'Show';
				id: string;
				flatrate: Array<{
					__typename?: 'Offer';
					id: string;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
					};
				}>;
		  };
};

export const TitleListOfferProviderFragmentDoc = gql`
	fragment TitleListOfferProvider on GenericTitleListEdge {
		nodeV2 {
			id
			... on MovieOrShowOrSeason {
				__typename
				flatrate: offers(country: $country, platform: WEB, filter: $offersFilter) {
					id
					package {
						id
						packageId
						clearName
						shortName
					}
				}
			}
		}
	}
`;
export const GetTitleListOfferProvidersDocument = gql`
	query GetTitleListOfferProviders(
		$nodeId: ID!
		$country: Country!
		$first: Int!
		$filter: TitleFilter
		$offersFilter: OfferFilter!
	) {
		node(id: $nodeId) {
			id
			... on GenericTitleList {
				titles(country: $country, first: $first, filter: $filter) {
					totalCount
					edges {
						...TitleListOfferProvider
					}
				}
			}
		}
	}
	${TitleListOfferProviderFragmentDoc}
`;
